import defaultAttributes from '../defaultAttributes';

const ChevronsDownUp = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M7 20l5-5 5 5' }], ['path', { d: 'M7 4l5 5 5-5' }]],
];

export default ChevronsDownUp;
